import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UnarchiveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"unarchive"}/>
}
